import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchEnv, type FetchEnvParams } from '../../api/fetchers/env/fetcher';

interface FetchEnvActionParams extends FetchEnvParams {
  essential: boolean;
}

export const fetchEnvAction = createAsyncThunk('env/fetchEnv', (params: FetchEnvActionParams) => fetchEnv(params));
